import { NavLink } from 'react-router-dom';

import myPhotoRight_Thumb1x from './../../assets/HomePage/MyPhotoThumbnail/My_Photo_Right_1x.webp';
import myPhotoRight_Thumb2x from './../../assets/HomePage/MyPhotoThumbnail/My_Photo_Right_2x.webp';
import closeIcon from '../../assets/icons/CloseIcon.svg'
import styles from './Header.module.css';
import { animateCSS } from '../../helpers/globals';

export default function HeaderComponent() {
    function closeMenuPanel() {
        if (window.innerWidth > 1150) return;

        const navBarPanel = document.getElementById("navBarPanel");

        if (navBarPanel) {
            animateCSS('#navBarPanel', 'animate__slideOutUp').then((message) => {
                // Do something after the animation
                navBarPanel.style.display = "none";
            });
        }
    }

    return (
        <nav className={styles.appBar}>
            <div className={styles.branding}>
                <img className={styles.myPhotoThumb} srcSet={myPhotoRight_Thumb1x + ', ' + myPhotoRight_Thumb2x + ' 2x'} src={myPhotoRight_Thumb1x} alt="Jagdish Thumbnail" />
                <NavLink to="/" className={styles.appTitle}>JAGDISH CHOPDE</NavLink>
                <img onClick={closeMenuPanel} className={styles.closeIcon} src={closeIcon} alt="Close Menu Panel" />
            </div>

            <ol className={styles.navs}>
                <li>
                    <NavLink to="/" className={({ isActive }) => isActive ? styles.active : undefined} onClick={closeMenuPanel}>Home</NavLink>
                </li>
                <li>
                    <NavLink to="/certifications" className={({ isActive }) => isActive ? styles.active : undefined} onClick={closeMenuPanel}>Certifications</NavLink>
                </li>
                <li>
                    <NavLink to="/awards" className={({ isActive }) => isActive ? styles.active : undefined} onClick={closeMenuPanel}>Awards & Recognitions</NavLink>
                </li>
                <li>
                    <NavLink to="/projects" className={({ isActive }) => isActive ? styles.active : undefined} onClick={closeMenuPanel}>Projects</NavLink>
                </li>
                <li>
                    <NavLink to="/memories" className={({ isActive }) => isActive ? styles.active : undefined} onClick={closeMenuPanel}>Memories</NavLink>
                </li>
            </ol>
        </nav>
    );
}